import { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import InitializeData from "../functional-components/InitializeData";
import Tracking from "../functional-components/Tracking";
import Routes from "../components/Routes";
import "../style/bjelin.scss";
import "../config/i18next";
import { cockpitCollectionPreviewDataListener } from "../utils/CockpitUtils";
import PrerenderRedirectStatus from "../components/PrerenderRedirectStatus";
import { ToolTipProvider } from "../components/ToolTip/Context";
import { CartContextProvider } from "../functional-components/CartContext";
import { UserContextProvider } from "../functional-components/UserContext";
import { UiMessageContextProvider } from "../components/UIMessages/context";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { reCaptchaSiteKey } from "../config/reCaptcha";
import { CssVariableContextProvider } from "../functional-components/CssVariableContext";

const Layout = () => {
  useEffect(() => {
    window.addEventListener("message", cockpitCollectionPreviewDataListener);

    return () =>
      window.removeEventListener(
        "message",
        cockpitCollectionPreviewDataListener
      );
  }, []);
  return (
    <>
      <Tracking />
      <CssVariableContextProvider>
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey}>
          <UiMessageContextProvider>
            <UserContextProvider>
              <InitializeData>
                <CartContextProvider>
                  <ToolTipProvider>
                    <Router>
                      <PrerenderRedirectStatus />
                      <Routes />
                    </Router>
                  </ToolTipProvider>
                </CartContextProvider>
              </InitializeData>
            </UserContextProvider>
          </UiMessageContextProvider>
        </GoogleReCaptchaProvider>
      </CssVariableContextProvider>
    </>
  );
};

export default Layout;
